import { createSelector } from 'reselect'

import { getHasInboxProduct } from 'common/core/selectors/appSelectors'

import { IAdminInterface } from '../interfaces'

export const isBotSettingsReady = (state: RootState): boolean => state.botSettings.ready

export const getBotAdmins = (state: RootState): IAdminInterface[] | null =>
  state.botSettings.admins.items

export const getBotAgents = createSelector(
  [getBotAdmins, getHasInboxProduct],
  (admins, hasInboxProduct): IAdminInterface[] => {
    if (!admins) return []

    return admins.filter((admin) => {
      return !hasInboxProduct || admin.is_inbox_user
    })
  },
)

export const getAgentsForAssigneePicker = createSelector(
  [getBotAgents],
  (paidUsers): Array<IAdminInterface & { value: number }> =>
    paidUsers.map((user) => ({ ...user, value: user.user_id })),
)

export const isBotSettingsFetching = (state: RootState): boolean => state.botSettings.fetching
